import { render } from "./YourDetailsSZG.vue?vue&type=template&id=fed92998&scoped=true"
import script from "./YourDetailsSZG.vue?vue&type=script&lang=js"
export * from "./YourDetailsSZG.vue?vue&type=script&lang=js"

import "./YourDetailsSZG.vue?vue&type=style&index=0&id=fed92998&lang=scss"
import "./YourDetailsSZG.vue?vue&type=style&index=1&id=fed92998&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed92998"]])

export default __exports__